export class Config {
    getConfig() {
        return this.config;
    }
    setConfig(conf) {
        this.config = conf;
    }
}
